import { isLanguage } from "./config";

export function languageFromPath(path: string) {
  const segment = path.split(/[/?#]/)[1];
  return isLanguage(segment) ? segment : undefined;
}

// These paths belong to services/static assets rather than the localized app.
export function isUnlocalizedPath(path: string) {
  return (
    /^\/(?:articles(?:\/|$)|(?:privacy|personvern|terms|bruksvilkar)(?:[/?#]|$))/.test(path) ||
    /^\/(?:api|blog|ingest|_next|__nextjs)(?:[/?#]|$)/.test(path) ||
    /\.(?:ico|png|jpg|jpeg|svg|webp|gif|avif|mp4|mp3|wav|webm|txt|xml|json|js|mjs|wasm|woff2?|ttf|pdf|zip|srt|vtt)$/i.test(
      path.split(/[?#]/)[0]
    )
  );
}

export function localizeHref(href: string, locale: HrefLang) {
  if (
    !href.startsWith("/") ||
    href.startsWith("//") ||
    isUnlocalizedPath(href) ||
    languageFromPath(href)
  )
    return href;
  return `/${locale}${href}`;
}

export function switchLanguage(href: string, locale: HrefLang) {
  const current = languageFromPath(href);
  const path = current ? href.slice(current.length + 1) : href;
  return localizeHref(path.startsWith("/") ? path : `/${path}`, locale);
}
